import { svg, html, css } from 'lit';
import { HyphenationModule } from '../js/modules/hyphenation.module';
import { LineClampModule } from '../js/modules/line-clamp.module';
import { NexusComponent } from './modules/nexus.component';
import { DebounceModule } from './modules/debounce.module';
import { LightDocumentObjectModelNexusComponent } from './modules/light-document-object-model-nexus-component';
/**
 * Progressively enhanced grid-item component.
 * Works with SEO while providing a base for js-based features.
 * Styles are encapsulated.
 */
export class GridItemComponent extends LightDocumentObjectModelNexusComponent {

    static properties = {
        title: {
            type: String,
            attribute: true,
        },
        // myBool: { type: Boolean },
    }

    sprites;

    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
			display: flex;  /* or display: block; */
            width: 100% !important;
			}
            .grid-item-component {
                width: 100%;
            }
		`;
    }
    constructor() {
        super();
        this.title = null;
        this.lineClampModule = new LineClampModule();
        this.lineClampModule.initialize();
        if (typeof document !== 'undefined') {
            this.triggerEventOnElement('constructor', document, this);
            this.triggerEventOnElement('constructor.grid-item.component', document, this);
        }
    }

    getSprites() {
        return svg`${this.sprites}`;
    }

    // // TODO: Important! Use 'updated' instead of 'update' because 'update' is used to update, and 'updated' is used to handle updated DOM
    updated() {
        super.updated();
        this.triggerEventOnElement('updated.grid-item.component', this.renderRoot, this);
    }

    connectedCallback() {
        super.connectedCallback();
        this.hyphenationModule = new HyphenationModule();
        this.triggerEventOnElement('connected.grid-item.component', this.renderRoot, this);
    }
    render() {
        var result = html`
        <div class="grid-item-component" component-loaded>
            <slot @slotchange=${this.handleSlotChange}></slot>
        </div>
        `;
        this.triggerEventOnElement('render.grid-item.component', this.renderRoot, this);
        return result;
    }

    handleSlotChange(event) {
        // console.log('handleSlotChange', event);
    }

    get _slottedChildren() {
        const slot = this.renderRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });
    }

    firstUpdated() {
        this._slottedChildren.forEach((element) => {
            this.hyphenationModule.setRoot(element);
            this.hyphenationModule.initialize();
        });
    }

}
window.customElements.define('grid-item', GridItemComponent);
